// src/utils/geoPreference.js
// Préférence utilisateur pour la géolocalisation, activée par défaut - NE PAS MODIFIER

const PREF_KEY = 'fynho_geo_preference';

export const getGeoPreference = () => {
  const stored = localStorage.getItem(PREF_KEY);
  if (stored === null) return true; // activé par défaut, comme demandé
  return stored === 'true';
};

export const setGeoPreference = (enabled) => {
  localStorage.setItem(PREF_KEY, String(enabled));
};